import { currencyCodes } from "../../../../constants.js";
const getFormattedPrice = (locale, price, removeZeroFractionDigits = false) => {
  if (!price && price !== 0) return;
  const isWholeNumber = price % 1 === 0 || price === 0;
  return new Intl.NumberFormat(locale, {
    currency: currencyCodes[locale],
    minimumFractionDigits: removeZeroFractionDigits && isWholeNumber ? 0 : 2,
    maximumFractionDigits: 2,
    style: "currency"
  }).format(price).replace("US", "").trim();
};
export {
  getFormattedPrice
};
